/**
 * Authentication-related constants
 */

export const AUTH_CONSTANTS = {
  /** Timeout for session checks in milliseconds */
  SESSION_CHECK_TIMEOUT_MS: 2000,
  /** Timeout for session refresh in milliseconds */
  SESSION_REFRESH_TIMEOUT_MS: 3000,
  /** Delay after writing token to localStorage in milliseconds */
  TOKEN_WRITE_DELAY_MS: 50,
  /** Delay before fetching user profile after login in milliseconds */
  PROFILE_FETCH_DELAY_MS: 100,
  /** Timeout for session setup during login in milliseconds */
  SESSION_SETUP_TIMEOUT_MS: 10000,
  /** Delay after user creation before login retry in milliseconds */
  USER_CREATION_DELAY_MS: 500,
  /** Delay between login retry attempts in milliseconds */
  LOGIN_RETRY_DELAY_MS: 1000,
  /** Maximum number of login retries after registration */
  MAX_LOGIN_RETRIES: 3,
  /** Timeout for auth initialization in milliseconds */
  INIT_TIMEOUT_MS: 5000,
} as const;
